import { Subscription } from "@/types/auth";
// Importados diretamente (e não do barrel "@/service") para evitar ciclo:
// o barrel reexporta services que dependem de utils/previewAccount, que por
// sua vez depende deste arquivo (getCachedSubscription).
import { reset403Error } from "@/service/api";
import { subscriptionsService } from "@/service/auth/subscriptions";
import { createResource } from "@/utils/createResource";

const subscriptionResource = createResource<Subscription>(async () => {
  const subscription = await subscriptionsService.getCurrentSubscription();
  reset403Error();
  return subscription;
});

export const refreshSubscriptionData = () => subscriptionResource.refresh();

// Assinatura atual fora de componentes React (ex.: funções de serviço). O
// DashboardLayout garante que ela esteja carregada antes das páginas.
export const getCachedSubscription = (): Subscription | null => subscriptionResource.get();

export const useSubscription = () => {
  const { data, loading, error, refresh } = subscriptionResource.useResource();
  return { subscription: data, loading, error, refreshSubscription: refresh };
};
